import {
    Box,
    Button,
    Container,
    Paper,
    Stack,
    TextField,
    Typography,
    Alert,
    CircularProgress,
} from '@mui/material';
import { useGlobalStore } from '../../application/store/store';
import { ProfileService } from './Services/ProfileService';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function UpdateProfile() {
    const navigate = useNavigate();
    const profile = useGlobalStore((state) => state.profile);
    const [isLoading, setIsLoading] = useState(false);
    const profileService = new ProfileService();

    const [formData, setFormData] = useState({
        firstName: profile?.firstName || '',
        lastName: profile?.lastName || '',
    });

    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const handleSave = async () => {
        setIsLoading(true);
        setErrorMessage(null);
        const result = await profileService.updateProfile(
            formData.firstName,
            formData.lastName
        );
        if (result.success) {
            profileService.getProfile();
            setIsLoading(false);
            navigate('..');
        } else {
            setIsLoading(false);
            setErrorMessage(result.error);
        }
    };

    return (
        <Container maxWidth="sm">
            <Box display="flex" alignItems="center" mb={2}>
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={() => navigate('..')}
                    color="primary"
                >
                    Tillbaka
                </Button>
            </Box>

            <Paper elevation={3} className="p-8 border-r-6">
                <Typography variant="h4" align="center" gutterBottom>
                    Ändra profil
                </Typography>
                <Box mt={2} mb={2} borderBottom={1} borderColor="divider" />

                {errorMessage && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {errorMessage}
                    </Alert>
                )}

                <Stack spacing={2}>
                    <TextField
                        label="Förnamn"
                        variant="outlined"
                        fullWidth
                        value={formData.firstName}
                        onChange={(e) =>
                            setFormData({
                                ...formData,
                                firstName: e.target.value,
                            })
                        }
                    />

                    <TextField
                        label="Efternamn"
                        variant="outlined"
                        fullWidth
                        value={formData.lastName}
                        onChange={(e) =>
                            setFormData({
                                ...formData,
                                lastName: e.target.value,
                            })
                        }
                    />
                </Stack>

                <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="center"
                    mt={3}
                >
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => navigate('..')}
                        sx={{ minWidth: '120px' }}
                    >
                        Avbryt
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSave}
                        sx={{ minWidth: '120px' }}
                        disabled={isLoading}
                    >
                        {isLoading ? <CircularProgress size={24} /> : 'Spara'}
                    </Button>
                </Stack>
            </Paper>
        </Container>
    );
}
